/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3RewardNodeProvidersFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3RewardNodeProvidersFormat = ClosedEnum<
  typeof GetApiV3RewardNodeProvidersFormat
>;

export type GetApiV3RewardNodeProvidersRequest = {
  maxRewardNodeProviderIndex?: number | null | undefined;
  format?: GetApiV3RewardNodeProvidersFormat | undefined;
  offset?: number | undefined;
  limit?: number | undefined;
};

/** @internal */
export const GetApiV3RewardNodeProvidersFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3RewardNodeProvidersFormat
> = z.nativeEnum(GetApiV3RewardNodeProvidersFormat);

/** @internal */
export const GetApiV3RewardNodeProvidersFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3RewardNodeProvidersFormat
> = GetApiV3RewardNodeProvidersFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3RewardNodeProvidersFormat$ {
  /** @deprecated use `GetApiV3RewardNodeProvidersFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3RewardNodeProvidersFormat$inboundSchema;
  /** @deprecated use `GetApiV3RewardNodeProvidersFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3RewardNodeProvidersFormat$outboundSchema;
}

/** @internal */
export const GetApiV3RewardNodeProvidersRequest$inboundSchema: z.ZodType<
  GetApiV3RewardNodeProvidersRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  max_reward_node_provider_index: z.nullable(z.number().int()).default(null),
  format: GetApiV3RewardNodeProvidersFormat$inboundSchema.default("json"),
  offset: z.number().int().default(0),
  limit: z.number().int().default(50),
}).transform((v) => {
  return remap$(v, {
    "max_reward_node_provider_index": "maxRewardNodeProviderIndex",
  });
});

/** @internal */
export type GetApiV3RewardNodeProvidersRequest$Outbound = {
  max_reward_node_provider_index: number | null;
  format: string;
  offset: number;
  limit: number;
};

/** @internal */
export const GetApiV3RewardNodeProvidersRequest$outboundSchema: z.ZodType<
  GetApiV3RewardNodeProvidersRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3RewardNodeProvidersRequest
> = z.object({
  maxRewardNodeProviderIndex: z.nullable(z.number().int()).default(null),
  format: GetApiV3RewardNodeProvidersFormat$outboundSchema.default("json"),
  offset: z.number().int().default(0),
  limit: z.number().int().default(50),
}).transform((v) => {
  return remap$(v, {
    maxRewardNodeProviderIndex: "max_reward_node_provider_index",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3RewardNodeProvidersRequest$ {
  /** @deprecated use `GetApiV3RewardNodeProvidersRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3RewardNodeProvidersRequest$inboundSchema;
  /** @deprecated use `GetApiV3RewardNodeProvidersRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3RewardNodeProvidersRequest$outboundSchema;
  /** @deprecated use `GetApiV3RewardNodeProvidersRequest$Outbound` instead. */
  export type Outbound = GetApiV3RewardNodeProvidersRequest$Outbound;
}

export function getApiV3RewardNodeProvidersRequestToJSON(
  getApiV3RewardNodeProvidersRequest: GetApiV3RewardNodeProvidersRequest,
): string {
  return JSON.stringify(
    GetApiV3RewardNodeProvidersRequest$outboundSchema.parse(
      getApiV3RewardNodeProvidersRequest,
    ),
  );
}

export function getApiV3RewardNodeProvidersRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3RewardNodeProvidersRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3RewardNodeProvidersRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3RewardNodeProvidersRequest' from JSON`,
  );
}
